
<div class="air-heading">Installation/Removal Date</div>

<div class="operation-details-container mt-10">
    <div class="partioned-table">
        <div class="row">
            <div class="cell label">Tag Number</div>
            <div class="cell value">
                <input pInputText type="text" (keydown.enter)="go()" [(ngModel)]="tagNumber" placeholder="Enter tag number" numericOnly [maxLength]="5">
                <span class="note">(Use numbers only, and leading zeros if necessary)</span>
            </div>
        </div>
        <div class="row">
            <div class="cell label"></div>
            <div class="cell value">
                <button pButton class="primary-btn h-20" [loading]="isLoading" (click)="go()">Go</button>
                <span *ngIf="tagError" class="error-message">Tag Number not found. Please try again.</span>
            </div>
        </div>
    </div>
</div>